import { angularServicesNames } from "@topline/services/angularServicesNames";

(function (module) {
    "use strict";

    module.component('quaterPpgTable', {
        template: require('./quaterPpgTableComponent.html'),
        bindings: {
            statisticalForecast: "<",
            pmForecast: "<",
            parameters: "<",
        },
        controller: ['$scope', angularServicesNames.$translate, 'PPGChartAndTableService', 'dtpChartService', 'ChartsConfig', 'calculationPPGService',
            function(
                this: $TSFixMe,
                $scope: $TSFixMe,
                $translate: ng.translate.ITranslateService,
                PPGChartAndTableService: $TSFixMe,
                dtpChartService: $TSFixMe,
                ChartsConfig: $TSFixMe,
                calculationPPGService: $TSFixMe
            ) {
                var $ctrl = this;
         
                $ctrl.$onInit = function () {
                    $scope.$watch('$ctrl.pmForecast', function (newVal: $TSFixMe) {
                        if (newVal) {
                            $ctrl.dataToQuartersTable = PPGChartAndTableService.prepareDataToQuartersPPGTable($ctrl.statisticalForecast, $ctrl.pmForecast, $ctrl.parameters.forecastStartDate);
                        }
                    });
                };
            }]
    });

})(angular.module('topline.modules'));